import moment from "moment";

export const getBuroMonthEndDate = (date) => {
  if (!moment.isMoment(date) || !date.isValid()) {
    return null;
  }

  return date.clone().endOf("month").format("YYYY-MM-DD");
};
